/*
 * <seatfit-vehicle-steps> (blocks/product_vehicle-steps.liquid): the reference "Customize Your Vehicle" buy
 * box on Shrine, for the product kind of the block setting (seat / cover / mat). Resolves ?year&make&model,
 * draws the steps, clicks Shrine's hidden option radios for the choice, carries the vehicle to the cart as
 * hidden properties and keeps the Buy button locked (capture phase) until every step is answered. Every pick
 * and variant change is written back to the URL, so a copied link restores the exact choice. Helpers loaded
 * before this file: SeatFitStepsModel, SeatFitShrine, SeatFitStepsOptions, SeatFitStepsSync (view + page).
 */
if (!customElements.get('seatfit-vehicle-steps')) {
  (function () {
    'use strict';
    var M = window.SeatFitStepsModel;
    var B = window.SeatFitShrine;
    var S = window.SeatFitStepsSync;
    var O = window.SeatFitStepsOptions;
    var READY_TIMEOUT_MS = 8000;

    function rawParams() {
      var sp = new URLSearchParams(location.search);
      var get = function (k) { return String(sp.get(k) || '').trim().slice(0, 40); };
      return { year: get('year'), make: get('make'), model: get('model') };
    }

    // `seat` is positional (slot i answers the set's i-th asked row) and a set change moves the rows,
    // so each answer is carried by its row: on a Ram both rows offer "40/20/40 Split Bench" and a front
    // answer left in slot 0 would become the rear seat type. Unanswered rows stay ''; no set yet = keep.
    function seatsForSet(sel, set, seat) {
      var ask = window.SeatFit.SUB_ROWS && window.SeatFit.SUB_ROWS[set];
      if (!sel || !sel.set || !sel.row || !ask) return seat;
      var byRow = {};
      (sel.subtypes || []).forEach(function (x) { if (x.value) byRow[x.row] = x.value; });
      var sub = sel.row.sub || {};
      return ask.filter(function (pos) { return sub[pos] && sub[pos].length; })
        .map(function (pos) { return byRow[pos] || ''; });
    }

    class SeatfitVehicleSteps extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        try {
          this.s = JSON.parse(this.querySelector('[data-sf-settings]').textContent) || {};
        } catch (e) {
          console.warn('[SeatFit] vehicle steps settings are not valid JSON', e);
          this.s = {};
        }
        this.body = this.querySelector('[data-sf-body]');
        this.inputsBox = this.querySelector('[data-sf-inputs]');
        this.open = {};
        this.complete = false;
        this.kind = ['cover', 'mat'].indexOf(this.s.kind) >= 0 ? this.s.kind : 'seat';
        this.shipDay = document.documentElement.dataset.seatfitShipDay || '';
        if (!M || !S || !B || !O) {
          console.warn('[SeatFit] vehicle steps helper scripts are missing');
          // A custom-fit product cannot be made without the vehicle: keep this product form from submitting.
          var info = this.closest('product-info');
          var form = info && info.querySelector('form[data-type="add-to-cart-form"]');
          this.listen(document, 'submit', (e) => { if (form && e.target === form) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
          return;
        }
        this.images = M.parseImages(this.s.option_images);
        this.shop = B.find(this, this.s);
        // Before anything can change a variant: otherwise Shrine's first change wipes year/make/model.
        B.keepUrl(this.shop);
        O.prepare(this);
        this.bind();
        this.paint();
        if (window.SeatFit && window.SeatFit.stepsFor) this.load();
        else this.waitForCore();
      }

      disconnectedCallback() {
        // The theme editor re-renders blocks; a stale instance must not keep locking the button.
        (this.unbind || []).forEach(function (fn) { fn(); });
        this.unbind = [];
        this.started = false;
      }

      waitForCore() {
        var done = false;
        var go = () => { if (!done) { done = true; this.load(); } };
        document.addEventListener('seatfit:ready', go, { once: true });
        setTimeout(() => {
          if (done) return;
          done = true;
          console.warn('[SeatFit] core scripts did not load');
          this.ctx = { status: 'none', reason: 'load-failed', make: null, model: null };
          this.update(false);
        }, READY_TIMEOUT_MS);
      }

      listen(target, type, fn, opts) {
        target.addEventListener(type, fn, opts);
        (this.unbind = this.unbind || []).push(function () { target.removeEventListener(type, fn, opts); });
      }

      bind() {
        this.listen(this, 'click', (e) => this.onClick(e));
        this.listen(this, 'change', (e) => this.onYear(e));
        // Capture phase on document runs before Shrine's ProductForm submit handler on the form,
        // and the button stays clickable so a click can take the shopper to the missing step.
        // A finished pick that still waits for Shrine's gallery (B.pending) would submit the old variant id.
        var hold = () => !this.complete || !!(B.pending && B.pending());
        this.listen(document, 'click', (e) => {
          if (hold() && B.isBuy(this.shop, e.target)) this.block(e);
        }, true);
        this.listen(document, 'submit', (e) => {
          if (hold() && this.shop.form && e.target === this.shop.form) this.block(e);
        }, true);
        // Bubble phase: Shrine's own 'change' listener on <variant-selects> has already run, so
        // currentVariant is the new one. Covers colour clicks and our own Seat Set radio clicks.
        this.listen(document, 'change', (e) => {
          var vs = e.target && e.target.closest ? e.target.closest('variant-selects') : null;
          if (vs && vs === this.shop.vs) this.afterVariant();
        });
        this.listen(document, 'seatfit:ship-day', (e) => {
          this.shipDay = (e.detail && e.detail.day) || '';
          this.paint();
        });
      }

      block(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        S.jump(this);
      }

      onClick(e) {
        var t = e.target.closest('[data-sf-act]');
        if (!t || !this.contains(t)) return;
        var act = t.dataset.sfAct;
        var v = t.dataset.sfValue;
        if (act === 'toggle') {
          var row = t.closest('.sf-step');
          this.open[t.dataset.sfKey] = row.classList.toggle('is-open');
          t.setAttribute('aria-expanded', String(row.classList.contains('is-open')));
          return;
        }
        if (act === 'retry') return this.load();
        if (act === 'step') this.picks[t.dataset.sfKey] = v;
        else if (act === 'gen') this.picks.gen = v;
        else if (act === 'set') {
          this.picks.seat = seatsForSet(this.sel, v, this.picks.seat);
          this.picks.set = v;
          this.setPicked = true;
          if (v === 'rear') this.revealRear = true;
        } else if (act === 'seat') {
          var seats = ((this.sel && this.sel.subtypes) || []).map(function (x) { return x.value || ''; });
          seats[Number(t.dataset.sfIdx) || 0] = v;
          this.picks.seat = seats;
        } else return;
        this.update(true);
      }

      onYear(e) {
        if (!e.target.matches('[data-sf-year]') || !this.ctx || !this.ctx.make || !this.ctx.model) return;
        var year = window.SeatFit.toYear(e.target.value);
        if (!year) return;
        window.SeatFit.writeParams({ year: year });
        this.resolveVehicle({ year: year, make: this.ctx.make.s, model: this.ctx.model.s }, true);
      }

      load() {
        var p = window.SeatFit.readParams();
        this.picks = { gen: p.gen, set: p.set, seat: p.seat };
        window.SeatFit.STEP_PARAMS.forEach((k) => { this.picks[k] = p[k]; });
        this.setPicked = !!p.set;
        this.revealRear = p.set === 'rear';
        this.wantColor = p.color;
        // Look first (?style=diamond): the colour picked after the vehicle resolves then lands in that style's colours.
        // A colour link without ?style= opens the style that sells it (?color=beige -> Diamond). Style products only.
        var C = window.SeatFitStyleColor;
        var look = p.style || (C && p.color ? C.styleFor(this.shop.vs, B.checked(this.shop, this.shop.styleName),
          p.color, this.shop.colorName) : '');
        // A look with nothing for sale right now (Classic while the supplier restocks) never opens the page, whatever
        // the link names (?style=, ?variant=, a colour only that look sells): the first look still for sale does.
        var S = window.SeatFitStyle;
        if (S && S.forSale) look = S.forSale(look || B.checked(this.shop, this.shop.styleName));
        if (look) O.choose(this, this.shop.styleName, look);
        this.resolveVehicle({ year: p.year, make: p.make, model: p.model }, false);
      }

      // A link colour the checked style does not sell -> its nearest sold colour (?style=diamond&color=tan -> Beige).
      linkColor(want) {
        var C = window.SeatFitStyleColor;
        if (!C) return want;
        return C.colorFor(this.shop.vs, B.checked(this.shop, this.shop.styleName), want, this.shop.colorName) || want;
      }

      // A newer request (year changed twice quickly) wins; an older answer is dropped.
      resolveVehicle(q, byShopper) {
        var token = this.token = (this.token || 0) + 1;
        this.loading = true;
        this.update(false);
        window.SeatFit.resolve(q, this.kind).then((ctx) => M.years(ctx).then((years) => {
          if (token !== this.token) return;
          this.ctx = ctx;
          this.years = years;
          this.loading = false;
          if (this.wantColor) O.choose(this, this.shop.colorName, this.linkColor(this.wantColor));
          this.wantColor = null;
          window.SeatFit.emit('vehicle', { ctx: ctx, source: 'vehicle-steps' });
          this.update(byShopper);
        })).catch((e) => {
          console.warn('[SeatFit] vehicle steps could not resolve the vehicle', e);
          if (token !== this.token) return;
          this.loading = false;
          this.ctx = { status: 'none', reason: 'load-failed', make: null, model: null };
          this.update(false);
        });
      }

      // byShopper: the shopper just picked something, so the link is rewritten; the first draw
      // after load leaves the ad link untouched.
      update(byShopper) { S.update(this, byShopper, rawParams()); }
      afterVariant() { S.afterVariant(this); }
      paint() { S.paint(this); }
    }

    customElements.define('seatfit-vehicle-steps', SeatfitVehicleSteps);
  })();
}
